import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';
// Import project images
import islamicdealsImg from '../../assets/images/islamicdeals.jpg';
import ufcSamplesImg from '../../assets/images/ufcsamples.jpg';
import xauJournalImg from '../../assets/images/xaujournal.jpg';
import thePetSiteImg from '../../assets/images/thepetsite.jpg';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: 'Investments & Trading Platform',
      category: 'web',
      image: xauJournalImg,
      useRealImage: true,
      description: 'XAUJournal.com is a comprehensive financial analytics platform providing sentiment analysis and expert insights for gold and USD markets. It features AI-powered trading bots with performance visualization, market sentiment tracking, and expert directories to help traders make informed investment decisions.',
      technologies: ['React', 'TypeScript', 'Material UI', 'Chart.js'],
      link: 'https://xaujournal.com'
    },
    {
      id: 2,
      title: 'Leading Sports News Website',
      category: 'web',
      image: ufcSamplesImg,
      useRealImage: true,
      description: 'UFC.news is a custom WordPress website featuring the latest UFC news, fighter profiles, and event coverage. Built with a responsive design, interactive elements using vanilla JavaScript, and optimized content organization for engaging user experience.',
      technologies: ['WordPress', 'PHP', 'CSS', 'JavaScript'],
      link: 'https://ufc.news'
    },
    {
      id: 3,
      title: 'Deal Sharing Platform',
      category: 'web',
      image: islamicdealsImg,
      useRealImage: true,
      description: 'IslamicDeals.com is a web application that aggregates and curates a variety of deals and discounts across categories such as local services, clothing, and lifestyle products. It enables users to discover and share offers, fostering a community-driven environment for deal-seekers.',
      technologies: ['React', 'PostgreSQL', 'Redux'],
      link: 'https://islamicdeals.com'
    },
    {
      id: 4,
      title: 'WooCommerce Pet Store',
      category: 'web',
      image: thePetSiteImg,
      useRealImage: true,
      description: 'ThePet.site is a comprehensive WooCommerce pet store featuring a wide range of pet products, accessories, and supplies. Built with WordPress and Elementor, it offers a seamless shopping experience with product catalogs, secure checkout, and customer-friendly design for pet enthusiasts.',
      technologies: ['WordPress', 'WooCommerce', 'Elementor', 'PHP'],
      link: 'https://thepet.site'
    }
  ];
  
  return (
    <section id="projects" className="projects section">
      <div className="container">
        <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Projects</h2>
          <p>A selection of recent work</p>
        </motion.div>
        
        <motion.div 
          className="projects-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, staggerChildren: 0.1 }}
        >
          {projects.map((project) => (
            <motion.div 
              className="project-card" 
              key={project.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              whileHover={{ y: -10 }}
            >
              <div className="project-image">
                {project.useRealImage ? (
                  <img src={project.image} alt={project.title} className="project-img" />
                ) : (
                  <div className={`placeholder-project ${project.image}`}></div>
                )}
                <div className="project-overlay">
                  <a href={project.link} className="btn project-btn" target="_blank" rel="noopener noreferrer">
                    View Project
                  </a>
                </div>
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div style={{flex: 1}}></div>
                <ul className="tech-list">
                  {project.technologies.map((tech, index) => (
                    <li key={index} className="tech-tag">{tech}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </motion.div>
        
        <div className="projects-cta">
          <a href="#contact" className="btn primary-btn">Let's Work Together</a>
        </div>
      </div>
    </section>
  );
};

export default Projects;